<template>
<div>
  <page-header :title="title" :url="url" :titleNew="titleNew"></page-header>
  <div class="row">
    <div class="col-md-4">
      <input-form-text textInput="Título" :required="true" v-model="filtro.titulo" :value="filtro.titulo" :layout="false"></input-form-text>
    </div>
    <div class="col-md-1"><br/>
      <button class="btn btn-primary" @click.prevent="getLimparFiltro">Limpar</button>
    </div>
  </div><br/>
  <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
  <grid ref="grid" :url="urlDataSource" :columns="columns" :GridHeight="400" :GridPageable="true" :DSpageSize="8" :DSserverPaging="true" :DSschema="true" :DSschemaData="'data'" :DSschemaTotal="'total'" :DSschemaParse="parse" :GridPageablePageSizes="[1, 10, 20, 100]" :DSfilter="filter" :DSserverFiltering="true"></grid>
</div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate'
import Permission from '@/mixins/Permission'
import TemplateCapa from './TemplateCapa'

import InputFormText from '@/components/form/InputForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

import moment from 'moment'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'titulo',
						operator: 'contains',
						value: this.filtro.titulo
					}
				]
			}
		},
		urlDataSource() {
			return `${this.$url}/v1/noticias?destaque=8`
		}
	},
	watch: {
		'filtro.titulo' () {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Notícias',
			titleNew: '',
			url: '/site/noticias/',
			columns: [{
				template: this.getTemplateCapa,
				title: 'Capa',
				width: 40,
			}, {
				field: 'datac',
				title: 'Data',
				width: 80
			}, {
				field: 'titulo',
				title: 'Título',
				width: 200
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 120
			}
			],
			filtro: {
				titulo: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				i.datac = moment(i.data).format('DD/MM/YYYY')
				delete i.data
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		getTemplateCapa(e) {
			return {
				template: TemplateCapa,
				templateArgs: {
					data: e
				}
			}
		},
		setFiltro() {
			let filtro = {
				titulo: this.filtro.titulo,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				titulo: null,
			}
			localStorage.setItem('_filtroNoticias', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.titulo,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/noticias/${item.id}`, 'delete').catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
		let filtro = localStorage.getItem('_filtroNoticias')
			? JSON.parse(localStorage.getItem('_filtroNoticias'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
